import service from "../../services/gestionEmpleados/assignWatch";
import watchesEmp from "../../models/gestionEmpleados/empleados/watchesEmp";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    service: new service(),
    watch: [],
    new: {},
    watchesAsign: [],
    deleteItem: {},
    editItems: [],
  },
  mutations: {
    setWatch(state, data) {
      state.watch = data;
    },
    setWatchesAsign(state, data) {
      state.watchesAsign = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
  },
  actions: {
    async getWatches({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getWatches();
        commit("setWatch", item);
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },

    async getWatchesAsign({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getWatchesAsign();
        commit("setWatchesAsign", item);
      } catch (error) {
        console.log(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },

    async newWatch({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.newWatch(state.new).then((data) => {
            const { empId, relojes, fecDesde, fecHasta } = data.data;

            const newItems = relojes.map((reloj) => {
              const relojAtributes = state.watch.find(
                (item) => item.relojId === reloj
              );
              return watchesEmp.fromJson({
                empId,
                relojId: relojAtributes.relojId,
                nomReloj: relojAtributes.nombre,
                descReloj: relojAtributes.descripcion,
                fecDesde,
                fecHasta: fecHasta || null,
              });
            });
            const updatedOptions = [...state.watchesAsign, ...newItems];
            commit("setWatchesAsign", updatedOptions);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async deleteWatch({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.deleteWatch(state.deleteItem).then(() => {
            let options = state.watchesAsign;
            options = options.filter((option) => {
              return option.relojId != state.deleteItem.relojId;
            });

            commit("setWatchesAsign", options);
            resolve(true);
          });
        } catch (error) {
          reject(error.response.data);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async editWatch({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          console.log("state.editItems", state.editItems);
          await state.service.edit(state.editItems).then(async () => {
            let item = await state.service.getWatchesAsign();
            commit("setWatchesAsign", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
